import React from 'react'
import Helmet from 'react-helmet'
import Contact from '../Contact'
import PropTypes from 'prop-types'

const ContactPageTemplate = ({
  title,
  subtitle,
  meta_title,
  meta_description,
  contacts,
}) => {
  return (
    <div>
      <Helmet>
        <title>{meta_title}</title>
        <meta name='description' content={meta_description} />
      </Helmet>
      <section className='hero is-primary is-bold'>
        <div className='hero-body'>
          <div className='container' style={{backgroundImage: 'url("/img/icon2.png")', backgroundRepeat: 'no-repeat', backgroundPosition: '85% 15%'}}>
            <div className='columns'>
              <div className='column is-10 is-offset-1'>
                <div className='section'>
                  <h1 className='title' style={{backgroundColor: 'rgb(36,47,64,0.3)'}}>
                    {title}
                  </h1>
                  <h2 className='subtitle' style={{backgroundColor: 'rgb(36,47,64,0.3)'}}>
                    {subtitle}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='section' style={{paddingTop: '1rem'}}>
        <div className='container'>
          {contacts.map((contact, id) =>
            <Contact key={id} email={contact.email} description={contact.description} />
          )}
        </div>
      </section>
    </div>
  )
}

ContactPageTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
  contacts: PropTypes.array,

}

export default ContactPageTemplate
